import type { TableOfContentsProps } from '@molecules/TableOfContents/TableOfContents.types';
import type { ReactElement } from 'react';

import { removeDigitAndDot } from '@/utils';

import { Ol, TableOfContentsWrapper } from './TableOfContents.styled';

export const TableOfContents = ({
  headingsList,
}: TableOfContentsProps): ReactElement => (
  <TableOfContentsWrapper>
    <h2>Spis treści</h2>
    <Ol
      id="tableOfContentsList"
      rowsNumber={Math.ceil(headingsList.length / 2)}
    >
      {headingsList.map(heading => (
        <li key={heading.id}>
          <a href={`#${heading.id}`}>{removeDigitAndDot(heading.title)}</a>
        </li>
      ))}
    </Ol>
  </TableOfContentsWrapper>
);
